import {observer} from 'mobx-react';
import {t} from 'shared/core';

const ProjectDoubleOvertimeCell = observer(({model}) => {
  return (
    <div>
      <div>{model.doubleOvertime}</div>
      {!!parseFloat(model.doubleOvertimeLieuTime) &&
        <div className='h6'>{t('time_tracking.payroll_hours.LIEU_TIME_EARNED', {lieuTime: model.doubleOvertimeLieuTime})}</div>}
    </div>
  );
});

export default ProjectDoubleOvertimeCell;
